import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SoundNotificationEngine } from '../../services/SoundNotificationEngine'

type Props = {
  initialVolume: number
  isMutating: boolean
  onSave: (volume: number) => void
}

export function SoundVolumeSection({ initialVolume, isMutating, onSave }: Props) {
  const { t } = useTranslation('settings')
  const { t: tc } = useTranslation('common')
  const [volume, setVolume] = useState(initialVolume)

  function handleTest() {
    const engine = SoundNotificationEngine.getInstance()
    engine.setVolume(volume)
    engine.play('reward')
  }

  function handleSave() {
    onSave(volume)
  }

  const pct = Math.round(volume * 100)

  return (
    <div className="card card-pad" style={{ marginBottom: 18 }} data-testid="sound-volume-section">
      <h3 style={{ marginBottom: 14 }}>{t('sound.title')}</h3>
      <div style={{ marginBottom: 14 }}>
        <label htmlFor="sound-volume" className="label">
          {t('sound.volumeLabel')}: <strong>{pct}%</strong>
        </label>
        <input
          id="sound-volume"
          type="range"
          min={0}
          max={1}
          step={0.01}
          value={volume}
          onChange={(e) => setVolume(parseFloat(e.target.value))}
          style={{ width: '100%', marginTop: 6 }}
          aria-label={t('sound.volumeAria', { pct })}
          data-testid="volume-slider"
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: 'var(--text-muted)' }}>
          <span>0%</span>
          <span>100%</span>
        </div>
      </div>
      <div className="row" style={{ gap: 8 }}>
        <button
          type="button"
          className="btn btn-sm"
          onClick={handleTest}
          data-testid="volume-test-btn"
        >
          {t('sound.test')}
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleSave}
          disabled={isMutating}
          data-testid="volume-save-btn"
        >
          {tc('actions.save')}
        </button>
      </div>
    </div>
  )
}
